import * as zod from 'zod';

export const GPUTaskRunnerState = zod.object({
  kind: zod.literal('GPUTaskRunner'),
  host: zod.string().optional(),
  isRunningInference: zod.boolean(),
  isConfiguringInference: zod.boolean(),
  isInitializing: zod.boolean(),
  skillsModels: zod.array(
    zod.object({
      modelFilenames: zod.array(zod.string()),
      modelMetadata: zod
        .object({
          trainingRun: zod.any(),
          botHardware: zod.any(),
        })
        .optional(),
      modelDirectory: zod.string(),
    }),
  ),
  visionModels: zod.array(
    zod.object({
      modelPath: zod.string(),
    }),
  ),
  isSkillsBotConnected: zod.boolean(),
  isVisionBotConnected: zod.boolean(),
  isSkillsBotEnabled: zod.boolean(),
  isVisionBotEnabled: zod.boolean(),
  inferenceStatus: zod.enum([
    'normal',
    'completed',
    'failed',
    'error',
    'movementCompletion',
  ]),
  inferenceFailureDetails: zod.string().optional().nullable(),
  cbSoftwareVersion: zod
    .object({
      buildId: zod.string(),
      buildName: zod.string(),
    })
    .optional(),
  gpuTaskRunnerSoftwareVersion: zod
    .object({
      buildId: zod.string(),
      buildName: zod.string(),
    })
    .optional(),
  versionMismatch: zod.boolean().optional(),
  complianceFlagsMismatch: zod.boolean().optional(),
});

export type GPUTaskRunnerState = zod.infer<typeof GPUTaskRunnerState>;
